import { render, staticRenderFns } from "./SelectComponents.vue?vue&type=template&id=f2b8c076&"
import script from "./SelectComponents.vue?vue&type=script&lang=js&"
export * from "./SelectComponents.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports